import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}




const createRouter=()=> new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/receiveCoupon/:couponId',
      name: '优惠券',
      component: () => import('./views/admin/coupon/receiveCoupon')
    },
    {
      path: '/',
      component: () => import('./views/index')
    },
    {
      path: '/company',
      component: () => import('./views/company')
    },
    {
      path: '/queryIccid',
      name: 'queryIccid',
      component: () => import("./views/queryIccid")
    },
    {
      path: '/auth',
      name: 'auth',
      component: () => import("./views/auth")
    },
    {
      path: '/success',
      name: 'success',
      component: () => import("./views/success")
    },
    {
      path: '/account',
      name: 'login',
      component: () => import('./views/login')
    },
    {
      path: '/accountTest',
      name: 'loginTest',
      component: () => import('./views/loginTest')
    },
    {
      path: '/accountTestSystem',
      name: 'loginTestSystem',
      component: () => import('./views/loginTestSystem')
    },
    /*{
      path: '/',
      redirect: '/agentlogin'
    },*/
    /*{
      path: '/agentlogin',
      name: 'agentlogin',
      component: () => import('./views/agentlogin')
    },*/
    {
      path: '/',
      name: 'admin',
      component: () => import('./views/admin'),
      meta: {
        loginRequire: true
      },
      children: [
        {
          path: 'system/poolPacket',
          name: '扩池套餐',
          component: () => import('./views/admin/pool/poolPacket')
        },
        {
          path: 'system/poolCard',
          name: '单卡列表',
          component: () => import('./views/admin/pool/singlecard')
        },
        {
          path: 'system/poolPanel',
          name: '仪表盘',
          component: () => import('./views/admin/pool/poolPanel')
        },
        {
          path: 'system/poolOrderList',
          name: '订单列表',
          component: () => import('./views/admin/pool/order')
        },
        {
          path: 'system/poolList',
          name: '流量池列表',
          component: () => import('./views/admin/pool/addPool')
        },
        {
          path: 'system/poolUser',
          name: '卡池用户',
          component: () => import('./views/admin/pool/userlist')
        },
        {
          path: 'welcome',
          name: '数据分析',
          component: () => import('./views/admin/welcome')
        },
        {
          path: 'welcome2',
          name: '数据分析',
          component: () => import('./views/admin/welcome2')
        },
        {
          path: 'system/loginuser',
          name: '用户列表',
          component: () => import('./views/admin/setup/loginuser')
        },
        {
          path: 'system/wechatuser',
          name: '客户列表',
          component: () => import('./views/admin/setup/wechatUser')
        },
        {
          path: 'system/serviceProcess',
          name: '售后审核',
          component: () => import('./views/admin/serviceProcess/serviceProcess')
        },
        {
          path: 'system/connectionDiagnosis',
          name: '连接诊断',
          component: () => import('./views/admin/card/connectionDiagnosis')
        },
        {
          path: 'system/card',
          name: '卡板列表',
          component: () => import('./views/admin/card/card')
        },
        {
          path: 'system/cardOut',
          name: '出卡列表',
          component: () => import('./views/admin/cardOut/cardOut')
        },
        {
          path: 'system/testMessage',
          name: '短信列表',
          component: () => import('./views/admin/message/textMessage')
        },
        {
          path: 'system/role',
          name: '角色权限',
          component: () => import('./views/admin/setup/role')
        },
        {
          path: 'system/sysSucOrderList',
          name: '成功订单',
          component: () => import('./views/admin/order/sysSucOrderList')
        },
        {
          path: 'system/sysFaiOrderList',
          name: '失败订单',
          component: () => import('./views/admin/order/sysFaiOrderList')
        },
        {
          path: 'system/sysRefundOrderList',
          name: '退款订单',
          component: () => import('./views/admin/order/sysRefundOrderList')
        },
        /*{
          path: 'system/sysOrderPreList',
          name: '预存明细',
          component: () => import('./views/admin/sysOrderPreList')
        },*/
        {
          path: 'system/resourcesList',
          name: '资源列表',
          component: () => import('./views/admin/card/resourcesList')
        },
        {
          path: 'menu',
          name: '设置菜单',
          component: () => import('./views/admin/offaccount/menu')
        },
        {
          path: 'menu_list',
          name: '公众号列表',
          component: () => import('./views/admin/offaccount/menu_list')
        },
        {
          path: 'commonProblem',
          name: '常见问题',
          component: () => import('./views/admin/offaccount/commonProblem')
        },
        {
          path: 'etc',
          name: '查看粉丝',
          component: () => import('./views/admin/offaccount/etc')
        },
        {
          path: 'menu_selinx',
          name: '客服管理',
          component: () => import('./views/admin/offaccount/menu_selinx')
        },
        {
          path: 'system/package_list',
          name: '套餐列表',
          component: () => import('./views/admin/package/package_list')
        },
        {
          path: 'system/packet_list',
          name: '加油包列表',
          component: () => import('./views/admin/package/packet_list')
        },
        {
          path: 'system/agent_list',
          name: '客户列表',
          component: () => import('./views/admin/custom/agent_list')
        },
        {
          path: 'system/sysProfitDetails',
          name: '分润详情',
          component: () => import('./views/admin/custom/sysProfitDetails')
        },
        {
          path: 'system/card_route',
          name: '通道列表',
          component: () => import('./views/admin/channel/route_list')
        },
        {
          path: 'system/route_yd',
          name: '移动通道',
          component: () => import('./views/admin/channel/route_yd')
        },
        {
          path: 'system/route_control',
          name: '通道管控',
          component: () => import('./views/admin/channel/route_control')
        },

        {
          path: 'system/financialFlow',
          name: '财务流水',
          component: () => import('./views/admin/finance/financialFlow')
        },

        {
          path: 'system/sysExtractRecord',
          name: '提现审核',
          component: () => import('./views/admin/finance/sysExtractRecord')
        },
        {
          path: 'system/sysOrderPreList',
          name: '预存明细',
          component: () => import('./views/admin/finance/sysOrderPreList')
        },
        {
          path: 'system/replaceList',
          name: '换卡列表',
          component: () => import('./views/admin/replaceList')
        },
        {
          path: 'system/logs',
          name: '系统日志',
          component: () => import('./views/admin/log/logs')
        },
        {
          path: 'system/businessLogs',
          name: '业务日志',
          component: () => import('./views/admin/log/businessLogs')
        },
        {
          path: 'system/batchRecharge',
          name: '业务受理',
          component: () => import('./views/admin/work/business')
        },
        /*{
          path: 'system/InitialFlow',
          name: '操作流量',
          component: () => import('./views/admin/InitialFlow')
        }, {
          path: "system/Coupon",
          name: "优惠券设置",
          component: () => import("./views/admin/Coupon")
        },
        {
          path: "system/couponList",
          name: "优惠券列表",
          component: () => import("./views/admin/couponList")
        },{
          path: 'system/riskControl',
          name: '风险管控',
          component: () => import('./views/admin/riskControl')
        },
        {
          path: 'system/supControl',
          name: '风险监控',
          component: () => import('./views/admin/supControl')
        },*/
        /*{
          path: 'system/overtimesRecord',
          name: '频次监控',
          component: () => import('./views/admin/overtimesRecord')
        },*/
        {
          path: 'system/task_list',
          name: '任务列表',
          component: () => import('./views/admin/task/task_list')
        },
        {
          path: 'system/disk_list',
          name: '磁盘列表',
          component: () => import('./views/admin/disk/disk_list')
        },
        /*{
          path: 'system/video',
          name: '视频教程',
          component: () => import('./views/admin/video')
        },*/
        {
          path: 'system/means',
          name: '资料文档',
          component: () => import('./views/admin/means/means')
        },
        {
          path: '/system/lottery',
          name: '抽奖发货',
          component: () => import('./views/admin/lottery/lottery.vue')
        }
        ,{
          path: 'system/monthlyUsedList',
          name: '月使用量列表',
          component: () => import('./views/admin/cost/monthlyUsedList')
        },{
          path: 'system/DailyUsedList',
          name: '日使用量列表',
          component: () => import('./views/admin/cost/dailyUsedList')
        },{
          path: '/system/valueAdded',
          name: '前端UI',
          component: () => import('./views/admin/business/valueAdded')

        },
        {
          path: '/system/feedback',
          name: '意见反馈',
          component: () => import('./views/admin/feedback/feedback')
        },
        {
          path: '/system/updImages',
          name: '更换LOGO/标题',
          component: () => import('./views/admin/updSystemImg/updImages')
        },
        {
          path: 'system/cardPacketDescInfo',
          name: '产品套餐详情',
          component: () => import('./components/card_packet_desc_info')
        },
        {
          path: 'system/profitCheck',
          name: '佣金提现',
          component: () => import('./views/admin/rebate/profitCheck')
        },
        {
          path: 'system/drawList',
          name: '提现明细',
          component: () => import('./views/admin/rebate/drawList')
        },
        {
          path: 'system/rabateList',
          name: '返佣列表',
          component: () => import('./views/admin/rebate/rabateList')
        },
        {
          path: 'system/riskControl',
          name: '风险管控',
          component: () => import('./views/admin/riskcontro/riskControl')
        },
        {
          path: '/system/couponList',
          name: '卡卷列表',
          component: () => import('./views/admin/coupon/couponList')
        },
        {
          path: '/system/couponOrder',
          name: '卡卷订单',
          component: () => import('./views/admin/coupon/couponOrder')
        },
        {
          path: 'system/equipment',
          name: '设备列表',
          component: () => import('./views/deviceModel/equipment')
        },
        {
          path: 'system/setupCode',
          name: '万人万相',
          component: () => import('./views/deviceModel/setupCode')
        },
        {
          path: 'system/deviceCode',
          name: '二维码',
          component: () => import('./views/deviceModel/deviceCode')
        },
        {
          path: 'system/violation',
          name: '投诉列表',
          component: () => import('./views/admin/violation/violationList')
        },
        {
          path: 'system/cert',
          name: '商户列表',
          component: () => import('./views/admin/violation/certList')
        },
      ]
    },
    /*{
      path: '/',
      name: 'agent',
      component: () => import('./views/agent'),
      meta: {
        loginRequire: true
      },
      children: [
        {
          path: 'agentWelcome',
          name: '欢迎',
          component: () => import('./views/agent/agentWelcome')
        },
        {
          path: 'agent/cardList',
          name: '卡列表',
          component: () => import('./views/agent/cardList')
        },
        {
          path: 'agent/agentList',
          name: '代理商列表',
          component: () => import('./views/agent/agentList')
        }, 
        {
          path: 'agent/sucOrderList',
          name: '成功订单',
          component: () => import('./views/agent/sucOrderList')
        },
        {
          path: 'agent/faiOrderList',
          name: '失败订单',
          component: () => import('./views/agent/faiOrderList')
        },
        {
          path: 'agent/packageList',
          name: '套餐列表',
          component: () => import('./views/agent/packageList')
        },
        {
          path: 'agent/packetList',
          name: '加油包列表',
          component: () => import('./views/agent/packetList')
        },
        {
          path: 'agent/loginUser',
          name: '用户列表',
          component: () => import('./views/agent/loginUser')
        },
        {
          path: 'agent/agentOrderPreList',
          name: '预存明细',
          component: () => import('./views/agent/agentOrderPreList')
        },
        {
          path: 'agent/agentProfitExtract',
          name: '分润提现', 
          component: () => import('./views/agent/agentProfitExtract')
        },
        {
          path: 'agent/rakeBackRecord',
          name: '返佣列表',
          component: () => import('./views/agent/rakeBackRecord')
        },
        {
          path: 'agent/profitDetails',
          name: '分润详情',
          component: () => import('./views/agent/profitDetails')
        },
        {
          path: 'agent/extractRecord',
          name: '提现列表',
          component: () => import('./views/agent/extractRecord')
        },
        {
          path: 'agent/batchRecharge',
          name: '批量充值',
          component: () => import('./views/agent/batchRecharge')
        },
        {
          path: 'agent/connectionDiagnosis',
          name: '智能诊断',
          component: () => import('./views/agent/connectionDiagnosis')
        },
        {
          path: 'agent/dailyUsedList',
          name: '日使用量列表',
          component: () => import('./views/agent/dailyUsedList')
        },
        {
          path: 'agent/monthlyUsedList',
          name: '月使用量列表',
          component: () => import('./views/agent/monthlyUsedList')
        },
        {
          path: 'agent/agent_rouute_list',
          name: 'agent/agent_rouute_list',
          component: () => import('./views/agent/card_route/agent_route_list')
        },
        {
          path: 'agent/agent_route_control',
          name: 'agent/agent_route_control',
          component: () => import('./views/agent/card_route/agent_route_control')
        },
        {
          path: 'agent/agent_route_swipe',
          name: 'agent/agent_route_swipe',
          component: () => import('./views/agent/card_route/agent_route_swipe')
        }
      ]
    },*/

    {
      path: '/',
      name: 'deviceModel',
      component: ()=>import('./views/admin'),
      meta: {
        loginRequire: true
      },
      children:[
        {
          path: 'deviceModel/dused',
          name: '套餐用量',
          component: () => import('./views/deviceModel/dused')
        },
        {
          path: 'deviceModel/dbuybag',
          name: '订购套餐',
          component: () => import('./views/deviceModel/dbuybag')
        },
        {
          path: 'deviceModel/dcontro',
          name: '控制列表',
          component: () => import('./views/deviceModel/dcontro')
        }
      ],
    },
  ]
})

const router = createRouter()
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
